import { useState, useRef, useEffect } from "react";

import { useNavigate } from "react-router-dom";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  ClickAwayListener,
  Divider,
  Paper,
  Popper,
} from "@mui/material";

// third-party
import Transitions from "./Tansitions";
import MainCard from "./MainCard";
import { Avatar, AvatarFallback, AvatarImage } from "../../components/ui/avatar";

import { useAuthContext } from "../../auth/hooks";
import { MenuCardList } from "./ProfileSection/menu-card-list";
import { ProfileUserDetail } from "./ProfileSection/profile-user-detail";

// assets

// ==============================|| PROFILE MENU ||============================== //

const role = localStorage.getItem('roleName')

const ProfileSection = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  /**
   * anchorRef is used on different componets and specifying one type leads to other components throwing an error
   * */
  const anchorRef = useRef<any>(null);


  const handleClose = (event: any) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };


  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <>
      <Avatar ref={anchorRef} className="rounded-xl cursor-pointer" onClick={handleToggle}>
        <AvatarImage src="https://github.com/shadcn.png" alt={'Cn'} />
        <AvatarFallback >CN</AvatarFallback>
      </Avatar>
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 14],
              },
            },
          ],
        }}
      >
        {({ TransitionProps }) => (
          <Transitions in={open} {...TransitionProps}>
            <Paper
      sx={{borderRadius:'20px'}}
      >
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard
                  border={false}
                  elevation={16}
                  content={false}
                  boxShadow
                  shadow={theme.shadows[16]}
                >

                  <ProfileUserDetail />
                  <Divider /> 
                  <MenuCardList setOpen={handleClose} />
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </>
  );
};

export default ProfileSection;
